import { Component, OnInit, HostListener } from '@angular/core';
import { Router,
         Event as RouterEvent,
         NavigationStart, 
         NavigationEnd}
from '@angular/router';
import * as jwt_decode from 'jwt-decode';
import { zip } from 'rxjs';

import { MorningMeetingService } from './attendance-status/morning-meeting.service';
import { AttendanceService } from './attendance-record/attendance.service';
import { LoginService } from './login/shared/login.service';
import { DataService } from './user-detail.service';
import { Staff } from './models/staff';
import { StaffService } from './shared/services/staff.service';
import { environment } from './../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    showSidebar: boolean;
    user: Staff = {
        _id: 0,
        name: '',
        katakana_name: '',
        display_name: '',
        katakana_display: '',
        profile_picture: '',
        email_pc: '',
        permit_level: 1,
        positions: [],
        departments: [],
        sections: [],
        branches: [],
        employment_status: '',
        employment_type: {}
    };
    showTimestampCebu: boolean = true;
    isAdmin = true;
    isLeader = true;
    showSideMenu = false;
    morning_meeting_notif = false;

    apps: any[] = [
        { name: 'GMS', logo: '../assets/app-icons/gms-icon.png', url: 'https://www.gm-system.net', access_permit: false },
        { name: '勤怠管理', logo: '../assets/app-icons/ams-icon.png', url: 'https://att-system.net', access_permit: false },
        { name: '申請システム', logo: '../assets/app-icons/apply-icon.png', url: 'https://request.gm-system.net', access_permit: false },
        { name: 'OMOTENASHI', logo: '../assets/app-icons/omotenashi-icon.png', url: 'https://omotenashi.gm-system.net/', access_permit: false },
        { name: 'File Share', logo: '../assets/app-icons/fileshare-icon.png', url: 'https://g-file-sharing.net/', access_permit: true },
        { name: '交通費精算\nフォーム', logo: '../assets/app-icons/gForms-icon.png', url: 'https://docs.google.com/forms/d/e/1FAIpQLScR3jzaF9NuY8sZNriKlFxljXTfkueXasvpGptGxZ5uXEt9AA/viewform', access_permit: true },
        { name: '経費精算\nフォーム', logo: '../assets/app-icons/gForms-icon.png', url: 'https://docs.google.com/forms/d/e/1FAIpQLSep5ird0yiQf4i1FS9B5YYkYLrZmkWAAXTEhWiAQPTe0x52dg/viewform', access_permit: true }
    ]

    constructor(
        private router: Router,
        private loginService: LoginService,
        private dataService: DataService,
        private morningMeetingService: MorningMeetingService,
        public attendanceService: AttendanceService,
        private staffService: StaffService
    ) {
        router.events.subscribe((event: RouterEvent) => {
            this.navigationInterceptor(event);
        });
    }

    @HostListener('window:message', ['$event'])
    onMessage(e) { 
        if (e.origin == environment.AUTH_URL) {
            let data = e.data;
            if (data.token) {
                localStorage.setItem('access_token', data.token);
                let staffId = jwt_decode(data.token)._id;
                zip(
                    this.staffService.getStaffById(staffId),
                    this.loginService.getAttendanceSetting(staffId)
                ).subscribe(res => {
                    this.dataService.setStaffInfo = res[0].data
                    this.dataService.setIndividualSettings = res[1];
                    this.user = res[0].data;
                    
                    // if there's a settings returned, set hasSettings.
                    if (res[1]) {
                        this.dataService.setHasSettings = true;
                    }

                    // event that notify subscribers that new token has been saved.
                    this.loginService.tokenSubject.next();
                })
            } else {
                // logout
                let loginSystem = `${environment.AUTH_URL}/home?action=logout&app=attendance`;
                window.location.href = loginSystem;
            }
        }         
    }

    ngOnInit() {
        // let token = localStorage.getItem('access_token');
        
        // if (token) {
        //     this.user = this.dataService.getStaffInformation;
        //     this.staffService.getStaffById(this.user._id).subscribe(
        //         (res) => {
        //             this.dataService.setStaffInfo = res.data;
        //         }
        //     )
        // }
        
        // Subscribe to morning meetin notification
        this.morningMeetingService.morning_meeting_notif.subscribe({
            next: () => {
              this.morning_meeting_notif = true;
              setTimeout(() => { 
                this.morning_meeting_notif = false; 
            }, 2000)
          },
          error: function(error) {
              console.log(error);
          }
        });
    }

    homeClicked() {
        if (this.router.routerState.snapshot.url !== '/attendance-record') {
            this.router.navigate(['/attendance-record']);
        }
    }

    navigationInterceptor(event: RouterEvent): void {
        if (event instanceof NavigationStart) {
            localStorage.setItem('previousRoute', event['url']);
            if (event.url === '/login' || event.url === '/unavailable-list' ) {
                this.showSidebar = false;
            } else {
                this.user = this.dataService.getStaffInformation
                this.showSidebar = true;
                this.checkIfCebuUser();
            }
        }

        if (event instanceof NavigationEnd) {
            localStorage.setItem('previousRoute', event['url']);
        }


    }

    logout() {
        this.loginService.logout();
    }

    checkIfCebuUser() {
        if (this.user) {
            this.loginService.getAttendanceSetting(this.user._id).subscribe(
                resp => {
                    this.showTimestampCebu = resp && resp.branch_office && resp.branch_office.search('セブ') === -1 ? false : true;
                    this.isAdmin = resp && resp.is_admin ? true : false;
                    this.isLeader = resp && resp.is_leader ? true : false;
                }, err => console.log(err)
            );
        }
    }

    closeSidebar(sidebar) {
        sidebar.close();
    }

}
